import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

//This is handling old bookmarks that may still be using hash routing
export class HashTagSerializer extends DefaultUrlSerializer implements UrlSerializer {
  parse(url: string): UrlTree {
    const newUrl = url.replace('#/', '');
    return super.parse(newUrl);
  }
}